import NumberFormat from "react-number-format";

export default function NumberFormatCustom(props: any) {
	const { inputRef, onChange, ...other } = props;

	return (
		<NumberFormat
			{...other}
			getInputRef={inputRef}
			onValueChange={values => {
				onChange &&
					onChange({
						currentTarget: {
							value: values.value
						},
						target: {
							value: values.value
						}
					});
			}}
		/>
	);
}

export function NumberFormatCustomFloat(props: any) {
	const { inputRef, onChange, ...other } = props;

	return (
		<NumberFormat
			{...other}
			getInputRef={inputRef}
			onValueChange={values => {
				onChange &&
					onChange({
						currentTarget: {
							value: values.floatValue
						},
						target: {
							value: values.floatValue
						}
					});
			}}
		/>
	);
}

export const CPF = (props: any) => (
	<NumberFormatCustom {...props} format="###.###.###-##" />
);

export const CNPJ = (props: any) => (
	<NumberFormatCustom {...props} format="##.###.###/####-##" />
);

export const CPFCNPJ = (props: any) => (
	<NumberFormatCustom
		{...props}
		format={
			props.value && props.value.length <= 11
				? "###.###.###-###"
				: "##.###.###/####-##"
		}
	/>
);

export const CODE = (props: any) => (
	<NumberFormatCustom {...props} format="####" />
);

export const IE = (props: any) => (
	<NumberFormatCustom {...props} format="###.###.###" />
);

export const CEP = (props: any) => (
	<NumberFormatCustom {...props} format="#####-###" />
);

export const PHONE = (props: any) => (
	<NumberFormatCustom {...props} format="## ####-#####" />
);

export const MONEY = (props: any) => {
	return (
		<NumberFormatCustomFloat
			prefix={"R$"}
			decimalSeparator=","
			thousandSeparator="."
			decimalScale={2}
			fixedDecimalScale
			{...props}
		/>
	);
};

export const PERCENTAGE = (props: any) => {
	return (
		<NumberFormatCustomFloat
			suffix={"%"}
			decimalSeparator=","
			thousandSeparator="."
			decimalScale={1}
			fixedDecimalScale
			{...props}
		/>
	);
};

export const PERCENTAGE2 = (props: any) => {
	return (
		<NumberFormatCustomFloat
			suffix={"%"}
			decimalSeparator=","
			thousandSeparator="."
			decimalScale={2}
			fixedDecimalScale
			{...props}
		/>
	);
};

export const DATE = (props: any) => (
	<NumberFormatCustom {...props} format="##/##/####" />
);
